function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 2.25h-.375c-1.046 0-1.569 0-2 .104a3.75 3.75 0 00-2.771 2.77c-.104.432-.104.955-.104 2.001V9.75c0 2.1 0 3.15.409 3.953a3.75 3.75 0 001.639 1.638c.802.409 1.852.409 3.952.409h2.625c1.046 0 1.569 0 2-.104a3.75 3.75 0 002.771-2.77c.104-.432.104-.955.104-2.001V10.5M9 9l6.75-6.75m0 0h-4.5m4.5 0v4.5",
  stroke: "#0063E3",
  strokeWidth: 1.125,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none"
  }, props), _ref);
};

export default SvgExternalLink;